/**
 *  提交表单
 *
 */

import { Form, Button } from 'antd';
import React, { useEffect } from 'react';
import { useHistory } from 'umi';

const layout = {
  // 标签长度
  labelCol: {
    span: 4,
  },
  // 表单长度
  wrapperCol: {
    span: 20,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 12,
    span: 12,
  },
};

const Demo = (props) => {
  const {
    okText,
    cancelText,
    formData = [],
    submit,
    onFinishFailed = () => {},
    refs,
    onCancel,
    readOnly = false,
  } = props;

  // console.log(refs);
  const history = useHistory();
  const [form] = Form.useForm();
  const onGoBack = () => {
    history.goBack();
  };
  const getSubmitFields = () => {
    return formData.map(
      ({ name, label, required, message, formItem, ...restProps }) => {
        return (
          <Form.Item
            name={name}
            label={label}
            key={name || label}
            {...restProps}
            rules={[
              {
                required: required || false,
                message: message || '请输入',
              },
            ]}
          >
            {formItem}
          </Form.Item>
        );
      },
    );
  };
  const onFinish = (values) => {
    // console.log(values);
    submit(values);
  };

  useEffect(() => {
    // refs.current.getFields = form.getFieldsValue;
    // refs.current.setFieldsValue = form.setFieldsValue;
    refs.current = {
      getFields: form.getFieldsValue,
      setFieldsValue: form.setFieldsValue,
    };
  }, [refs, form]);

  // const onReset = () => {
  //   form.resetFields();
  // };

  // const onFill = () => {
  //   form.setFieldsValue({
  //     note: 'Hello world!',
  //     gender: 'male',
  //   });
  // };

  return (
    <Form
      {...layout}
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <fieldset disabled={readOnly} style={{ border: 'none', padding: 0, margin: 0 }}>
        {getSubmitFields()}
      </fieldset>

      {!readOnly && (
        <Form.Item {...tailLayout}>
          <Button htmlType="button" onClick={onCancel || onGoBack}>
            {cancelText || '取消'}
          </Button>
          <Button type="primary" htmlType="submit" style={{ marginLeft: 20 }}>
            {okText || '确认'}
          </Button>
        </Form.Item>
      )}
    </Form>
  );
};

export default Demo;
